import { render, staticRenderFns } from "./EntitySubscription.vue?vue&type=template&id=9870bb00&scoped=true"
import script from "./EntitySubscription.vue?vue&type=script&lang=js"
export * from "./EntitySubscription.vue?vue&type=script&lang=js"
import style0 from "./EntitySubscription.vue?vue&type=style&index=0&id=9870bb00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9870bb00",
  null
  
)

export default component.exports